import { render } from "./App.vue.js?vue&type=template&id=15e9852d!=!../../node_modules/.pnpm/rspack-vue-loader@17.5.0_@r_d6affee338090c2ccb905a37584a1343/node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./App.vue?vue&type=template&id=15e9852d"
const script = {}

import exportComponent from "../../node_modules/.pnpm/rspack-vue-loader@17.5.0_@r_d6affee338090c2ccb905a37584a1343/node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__